import React from "react";
import { Heading } from "grommet";
import { useTranslation } from "react-i18next";
import { useFetchHotel } from "../redux/hooks";
import ConversationWithAI from "../ConversationWithAI";

export default function GuestAITestConversation() {
  const { t } = useTranslation();
  const { hotel } = useFetchHotel();
  return <section className="ai-training-test" aria-labelledby="guest-ai-test-title">
    <header>
      <Heading level={3} margin="none" id="guest-ai-test-title">{t("settingsTraining.testTitle")}</Heading>
      <p>{t("settingsTraining.testHelp")}</p>
      <details>
        <summary>{t("settingsTraining.testHowTitle")}</summary>
        <ol>
          <li>{t("settingsTraining.testHowQA")}</li>
          <li>{t("settingsTraining.testHowSources")}</li>
          <li>{t("settingsTraining.testHowTry")}</li>
        </ol>
      </details>
    </header>
    <ConversationWithAI key={hotel?._id} panel testAsGuest />
  </section>;
}
